import { M as Modal } from "./modal-C2lX66I4.js";
import { l as lock, u as unlock } from "./tua-bsl-uIxvG2ZV.js";
class AccountOverlay extends Modal {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setEventListeners();
    super.connectedCallback();
  }
  setEventListeners() {
    document.addEventListener("modal:show", (event) => {
      const customEvent = event;
      const modalName = customEvent.detail.modalName;
      if (modalName === "account-overlay") {
        return;
      }
      this.hideAccountOverlay();
    });
    document.addEventListener("modal:closed:account-overlay", () => {
      this.hideAccountOverlay();
    });
    document.addEventListener(
      "predictive-search:visible",
      () => this.hideAccountOverlay(false)
    );
  }
  closeDesktopNavigation() {
    const desktopMenu = document.querySelector("uwp-desktop-menu");
    if (desktopMenu == null ? void 0 : desktopMenu.closeAllDropdowns) {
      desktopMenu.closeAllDropdowns();
    }
  }
  toggleButtonActiveClass() {
    const accountOverlayButton = document.querySelector(
      "[js-header='accountOverlay']"
    );
    this.isAccountOverlayShowing() ? accountOverlayButton == null ? void 0 : accountOverlayButton.classList.add("is-open") : accountOverlayButton == null ? void 0 : accountOverlayButton.classList.remove("is-open");
  }
  toggleAccountOverlay() {
    this.isAccountOverlayShowing() ? this.hideAccountOverlay() : this.showAccountOverlay();
  }
  isAccountOverlayShowing() {
    return this.classList.contains("is-open");
  }
  showAccountOverlay() {
    const openModals = document.querySelectorAll(
      ".modal.is-open, .drawer.is-open, .search-input--desktop.is-active"
    );
    openModals.forEach((modal) => {
      if (modal.classList.contains("modal") || modal.classList.contains("drawer")) {
        const hideMethod = modal.hideModal || modal.hideDrawer;
        if (hideMethod) {
          hideMethod.call(modal);
        }
      }
    });
    super.showModal();
    this.closeDesktopNavigation();
    lock(this);
    const header = document.querySelector(
      ".header-background, .header-background-transparent"
    );
    const listElement = this.querySelector(
      ".account-overlay__list"
    );
    if (listElement && header && header.classList.contains("header-background-transparent")) {
      listElement.style.borderRadius = "8px";
      listElement.style.overflow = "hidden";
      listElement.style.paddingTop = "32px";
    } else if (listElement) {
      listElement.style.borderRadius = "";
      listElement.style.overflow = "";
      listElement.style.paddingTop = "";
    }
  }
  hideAccountOverlay(restoreFocus = true) {
    if (!this.isAccountOverlayShowing()) {
      return;
    }
    const listElement = this.querySelector(
      ".account-overlay__list"
    );
    if (listElement) {
      listElement.style.borderRadius = "";
      listElement.style.overflow = "";
      listElement.style.paddingTop = "";
    }
    super.hideModal(restoreFocus);
    unlock(this);
  }
}
customElements.define("uwp-account-overlay", AccountOverlay);
